module.exports = "<div class=download-screen__contents ng-show=$ctrl.options.active> <div class=download-screen__cover-container> </div> <div class=download-screen__options> </div> </div> <div class=download-screen__share-button ng-if=\"$ctrl.AppServices.DataManager.config.settings.isSharingEnabled \"> <div class=share-button ng-click=$ctrl.shareThisImage()></div> <div class=share-button-overlay><img ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}comic-download/SHARE_BACKING.png alt=\"\"/></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/download-screen/download-screen.html
 ** module id = 79
 ** module chunks = 0
 **/